import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Row, Table, Button, Form, Input, Select, Checkbox, Spin, Space, DatePicker, Upload, Radio, Col } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message'; // 提示信息弹窗
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import { ContextHandler } from '../../public/js/contextHandler';
import './survey.css';
import trans from './translation';

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

const Survey = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tablesRecord, setTablesRecord] = useState([]);
    const [tablesCountRecord, setTablesCountRecord] = useState(0);
    const [currentRecord, setCurrentRecord] = useState(1);
    const [pageSizeRecord, setPageSizeRecord] = useState(10);
    const [searchRecordModel, setSearchRecordModel] = useState({});
    const [oldSearchRecordModel, setOldSearchRecordModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [surveyTemplateList, setSurveyTemplateList] = useState([]);
    const [deleteTipText, setDeleteTipText] = useState("");
    const [surveyEndDays, setSurveyEndDays] = useState("");
    const [surveyRemindEmailDays, setSurveyRemindEmailDays] = useState("");
    const [optionTables, setOptionTables] = useState([]);
    const [questionTables, setQuestionTables] = useState([]);
    const [language, setLanguage] = useState("EN");
    const [surveyRecordModel, setSurveyRecordModel] = useState({});
    const [surveyTemplateModel, setSurveyTemplateModel] = useState({});
    const [surveyModel, setSurveyModel] = useState({});

    useEffect(() => {
        search(pageSize, 1, "N");
        searchSurvetTemplateList();
        searchSurveyEndDays();
        searchSurveyRemindEmailDays();
    }, []);

    const searchSurveyEndDays = () => {
        let model = {
            "segment": 'SYSTEM_CONFIG',
            "code": 'SURVEY_END_DAYS',
        }
        Base.callBackApi("commonDropDown/searchSysParam", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let days = data.object?.[0]?.parmValue1 ?? 0;
                setSurveyEndDays(days);
            } else {
                errFrameShow('error', data.msg);
            }
        }).catch(err => { });
    }

    const searchSurveyRemindEmailDays = () => {
        let model = {
            "segment": 'SYSTEM_CONFIG',
            "code": 'SURVEY_REMIND_EMAIL_DAYS',
        }
        Base.callBackApi("commonDropDown/searchSysParam", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let days = data.object?.[0]?.parmValue1 ?? 0;
                setSurveyRemindEmailDays(days);
            } else {
                errFrameShow('error', data.msg);
            }
        }).catch(err => { });
    }

    const searchSurvetTemplateList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("surveyTemplate/searchAll").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setSurveyTemplateList(list)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("survey/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const searchRecord = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        if (isShowMsg) {
            messageShowHandler();  // 清除提示信息
        }
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchRecordModel;
        } else {
            model = searchRecordModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("survey/searchRecord", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchRecordModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCountRecord(data?.object?.total ?? 0);
                setTablesRecord(data?.object?.list ?? []);
                setCurrentRecord(currentPageNew);
                setPageSizeRecord(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchRecordChange = (key, value) => {
        messageShowHandler();
        setSearchRecordModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const resetRecord = () => {
        messageShowHandler();
        setSearchRecordModel({surveyId: selectedRowKeys[0]});
        setOldSearchRecordModel({});
        setTablesCountRecord(0);
        setTablesRecord([]);
        setPageSizeRecord(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({
            endDate: moment().add(surveyEndDays, 'days'),
            remindEmailDate: moment().add(surveyRemindEmailDays, 'days'),
        });
        setSurveyModel({});
        setFileList([])
        setFlag("add");
        setTabIndex("2");
    }

    const update = (model, e) => {
        messageShowHandler();
        searchById(model.surveyId);
        setFlag("edit");
        setTabIndex("2");
    }

    const updateRecord = (model, e) => {
        messageShowHandler();
        searchRecordById(model);
        setTabIndex("3");
    }

    const edit = () => {
        setFlag("edit");
        searchById(selectedRowKeys[0]);
        setTabIndex('2');
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            surveyTemplateId: model.surveyTemplateId ?? "",
            description: model.description ?? "",
            receiver: model.receiver ?? "",
            endDate: model.endDate ? moment(new Date(model.endDate), Config.dateFormat5) : "",
            remindEmailDate: model.remindEmailDate ? moment(new Date(model.remindEmailDate), Config.dateFormat5) : "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = checkboxState[0];
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("survey/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        values.menuFuncId = Config.funcInfo.funcId;
        values.fileList = '';
        if (flag === "add") {
            let formData = new FormData();
            let file = fileList[0].originFileObj;
            formData.append("file", file);
            formData.append("model", JSON.stringify(values));
            fetch(Config.apiDownloadServer + 'surveyHandler/uploadExcel', {
                method: 'POST',
                body: formData,
                headers: { 'authorization': Config.header.authorization, 'x-auth-token': Config.header['x-auth-token'], 'func': Config.header.func },
                mode: 'cors',
                cache: 'default'
            }).then(res => res.blob()).then(blob => {
                if (blob.type == "application/json") {
                    var reader = new FileReader();
                    reader.onload = e => {
                        var data = JSON.parse(e.target.result);
                        if ("SUCCESS" === data.msg) {
                            searchById(data.object)
                            errFrameShow("success", trans.saveSuccess[Config.backLang]);
                        } else {
                            errFrameShow("error", data.msg);
                        }
                    }
                    reader.readAsText(blob);
                } else {
                    let filename = "SurveyTemplateErrorLog.xlsx";
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                        window.navigator.msSaveOrOpenBlob(blob, filename);
                    } else {// for Non-IE (chrome, firefox etc.)
                        var a = document.createElement('a');
                        document.body.appendChild(a);
                        a.style = 'display: none';
                        var url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = filename;
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    }
                }
            }).catch(err => ({ err })).finally(() => {
                setIsLoad(false)
            });
        } else {
            let url = "";
            if (flag == "duplicate") {
                url = "survey/insert";
                values.surveyRecordModelList = tablesRecord;
            } else {
                url = "survey/update";
                values.surveyId = selectedRowKeys[0];
                values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
            }
            Base.callBackApi(url, values).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchById(data.object)
                    errFrameShow("success", trans.saveSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => {
                setIsLoad(false);
            });
        }
    }

    const searchById = (surveyId, flag = true) => {
        setIsLoad(true);
        Base.callBackApi("survey/searchById", surveyId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object;
                initForm(model);
                setSurveyModel(model);
                setCheckboxState([model]);
                setSelectedRowKeys([model.surveyId]);
                if (flag) {
                    setFlag("edit");
                }
                searchRecordModel.surveyId = model?.surveyId
                searchRecord(pageSizeRecord, 1, "N");
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setDeleteTipText("Sending ID" + ":" + model.surveyId + "")
        setCheckboxState([model])
        setIsDeleteFrame(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //分页 页码切换变化查询
    const onChangeRecord = (currentNew, pageSizeNew) => {
        searchRecord(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChangeRecord = (currentNew, pageSizeNew) => {
        searchRecord(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const uploadChange = (e) => {
        messageShowHandler();
        setFileList([e.file]);
    }

    const removeFile = () => {
        setFileList([]);
        form.setFieldValue('fileList', '');
    }

    const downloadTemplate = () => {
        setIsLoad(true);
        setSpinInfo(trans.loading[Config.backLang]);
        fetch(Config.apiDownloadServer + "surveyTemplate/exportTemplate", {
            method: 'POST',
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "SurveyTemplate.xlsx";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    const searchRecordById = (model) => {
        setIsLoad(true);
        Base.callBackApi("survey/searchRecordById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                searchSurveyTemplate(model);
                setSurveyRecordModel(model);
                initForm2(model);
            } else {
                errFrameShow('error', data.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchSurveyTemplate = (model) => {
        setIsLoad(true);
        Base.callBackApi("survey/searchSurveyTemplate", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setSurveyTemplateModel(model);
                let list = [];
                for(let i = 1; i <= 10; i++) {
                    if(model['sectionAQuestion' + i + language]) {
                        list.push({
                            id: 'sectionAQuestionResult' + i,
                            question: model['sectionAQuestion' + i + language],
                        })
                    }
                }
                setQuestionTables(list);
                let optionList = [];
                for(let i = 1; i <= 13; i++) {
                    if(model['sectionCQuestion' + i + language]) {
                        optionList.push({
                            id: 'sectionCQuestionResult' + i,
                            question: model['sectionCQuestion' + i + language],
                        })
                    }
                }
                setOptionTables(optionList);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const initForm2 = (model = {}) => {
        form2.resetFields();
        form2.setFieldsValue({
            cohortProgIds: model.cohortProgIds ? model.cohortProgIds.split(',') : "",
            organisationName: model.organisationName ?? "",
            sectionAQuestionResult1: model.sectionAQuestionResult1 ?? "",
            sectionAQuestionResult2: model.sectionAQuestionResult2 ?? "",
            sectionAQuestionResult3: model.sectionAQuestionResult3 ?? "",
            sectionAQuestionResult4: model.sectionAQuestionResult4 ?? "",
            sectionAQuestionResult5: model.sectionAQuestionResult5 ?? "",
            sectionAQuestionResult6: model.sectionAQuestionResult6 ?? "",
            sectionAQuestionResult7: model.sectionAQuestionResult7 ?? "",
            sectionAQuestionResult8: model.sectionAQuestionResult8 ?? "",
            sectionAQuestionResult9: model.sectionAQuestionResult9 ?? "",
            sectionAQuestionResult10: model.sectionAQuestionResult10 ?? "",
            sectionBQuestionResult1: model.sectionBQuestionResult1 ?? "",
            sectionCQuestionResult1: model.sectionCQuestionResult1 ?? "",
            sectionCQuestionResult2: model.sectionCQuestionResult2 ?? "",
            sectionCQuestionResult3: model.sectionCQuestionResult3 ?? "",
            sectionCQuestionResult4: model.sectionCQuestionResult4 ?? "",
            sectionCQuestionResult5: model.sectionCQuestionResult5 ?? "",
        });
    }

    const duplicate = (model, e) => {
        e.stopPropagation();
        messageShowHandler()
        setFlag("duplicate");
        setTabIndex("2");
        searchById(model.surveyId, false);
    }

    const handleSelectSurveyTemplate = (surveyTemplateId) => {
        let model = surveyTemplateList?.find(item => item.surveyTemplateId == surveyTemplateId);
        form.setFieldValue('description', model?.description);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Sending ID',
            dataIndex: 'surveyId',
            className: 'tableWidth20',
        },
        {
            title: 'Cohort',
            dataIndex: 'cohortYear',
            className: 'tableWidth30',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            className: 'tableWidth50',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: 180,
            render: text => ContextHandler.getMapValue('surveyStatusMap', text),
        },
        {
            title: "Operation",
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 206,
            render: (text, record) => <div className='operation'>
                {/* <div className='sysUpdate' onClick={(e) => duplicate(record, e)} hidden={Config.funcInfo.canInsert === "N"}><CopyOutlined /> Duplicate</div> */}
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> Edit</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> Delete</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> Log</div>
            </div>
        },
    ];

    const columnsRecord = [
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: 'tableWidth35',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            className: 'tableWidth35',
        },
        ...(flag != "duplicate" ? [
            {
                title: 'Complection Date',
                dataIndex: 'completedDate',
                className: 'tableWidth30',
                render: text => text ? moment(text).format(Config?.dateFormatEn) : ''
            },
            {
                title: 'Status',
                dataIndex: 'status',
                width: 180,
                render: text => ContextHandler.getMapValue('surveyRecordStatusMap', text),
            },
            {
                title: "Operation",
                dataIndex: '',
                className: 'sysControls',
                fixed: 'right',
                width: 140,
                render: (text, record) => (
                    <div className='operation'>
                        <div 
                            className='sysUpdate' 
                            onClick={(e) => updateRecord(record, e)} 
                            hidden={Config.funcInfo.canView === "N"}
                        >
                            <EyeOutlined /> View
                        </div>
                        <div className='sysLogs' onClick={(e) => audit(record, e)}>
                            <EyeOutlined /> Log
                        </div>
                    </div>
                ),
            }
        ] : []),
    ];


    return (
        <div id="container" className="template survey">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />     
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab="List">
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle ">{trans.cohortYear[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]}
                                                value={searchModel.surveyTemplateId || ''}
                                                onChange={(e) => searchChange('surveyTemplateId', e)}
                                            >
                                                <Option value=''></Option>
                                                {surveyTemplateList.map((item) => <Option key={item.surveyTemplateId} value={item.surveyTemplateId}>{item.cohortYear}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">Status</div>
                                        <div className="sysSerchInput">
                                            <Select className="sysSelect" placeholder='Status'
                                                value={searchModel.status || ''}
                                                onChange={(e) => searchChange('status', e)}
                                            >
                                                <Option value=""></Option>
                                                {context.surveyStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>New Evaluation Survey</Button>
                                <Button className='sysBtn btnBlue' type="primary" onClick={downloadTemplate} hidden={Config.funcInfo.canUpload === "N"} icon={<DownloadOutlined />}>{trans.downloadTemplate[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1000 }}
                                    rowKey="surveyId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab="Evaluation Survey Sending & Record" forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Cohort</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="surveyTemplateId"
                                                rules={[
                                                    { required: true, message: trans.cohortYearNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]} disabled={flag == 'edit'}
                                                    onChange={(e) => handleSelectSurveyTemplate(e)}
                                                >
                                                    <Option value=''></Option>
                                                    {surveyTemplateList.map((item, index) => <Option key={item.surveyTemplateId} value={item.surveyTemplateId}>{item.cohortYear}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Description</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="description"
                                                rules={[
                                                    {
                                                        required: true, message: 'Description is required.'
                                                    },
                                                ]}
                                            >
                                                <Input type="text" maxLength={150}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Evaluation Survey End Date</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="endDate"
                                                rules={[
                                                    {
                                                        required: true, message: 'Evaluation Survey End Date is required.'
                                                    },
                                                ]}
                                            >
                                                <DatePicker placeholder="Evaluation Survey End Date"
                                                    className="parts-numberInput datePickerAllWidth"
                                                    allowClear={true}
                                                    onChange={() => form.validateFields(['remindEmailDate'])}
                                                    format={Config.dateFormat5} 
                                                    disabled={surveyModel?.status == 'COMPLETED'}
                                                    />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Evaluation Survey Remind Email Date</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="remindEmailDate"
                                                rules={[
                                                    {
                                                        required: true, message: 'Evaluation Survey Remind Email Date is required.'
                                                    },
                                                    {
                                                        validator: (_, value) => {
                                                            const endDate = moment(form.getFieldValue('endDate'));
                                                            if (value && endDate && value.isAfter(endDate)) {
                                                                return Promise.reject(new Error('Evaluation Survey Remind Email Date must be earlier than Evaluation Survey End Date.'));
                                                            }
                                                            return Promise.resolve();
                                                        }
                                                    }
                                                ]}
                                            >
                                                <DatePicker placeholder="Evaluation Survey Remind Email Date"
                                                    className="parts-numberInput datePickerAllWidth"
                                                    allowClear={true}
                                                    format={Config.dateFormat5} 
                                                    disabled={surveyModel?.status == 'COMPLETED'}
                                                    />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Receiver</div>
                                        {flag == 'add' ?
                                            <div className="" style={{width:"400px",marginLeft:"20px"}}>
                                                <div style={{ float: "left " }}>
                                                    <Form.Item
                                                        name="fileList"
                                                        rules={[
                                                            {
                                                                required: true, message: 'Receiver is required.'
                                                            },
                                                        ]}
                                                    >
                                                        <Upload
                                                            action={Config.uploadTestServer}
                                                            key="uploadFile"
                                                            accept={".xlsx,.xls"}
                                                            maxCount={1}
                                                            fileList={fileList}
                                                            onChange={(e) => uploadChange(e)}
                                                            showUploadList={false}>
                                                            <Button icon={<UploadOutlined />}>Select File</Button>
                                                        </Upload>
                                                    </Form.Item>
                                                </div>
                                                <span style={{ marginLeft: "10px", float: "left", height: "32px", lineHeight: "32px" }}>
                                                    {Base.isNotEmpty(fileList) ?
                                                        <div style={{ display: "flex", maxWidth: "400px" }}>
                                                            <div className='fileNameCl' style={{ color: "#000" }} >
                                                                {fileList[0].name}
                                                            </div>
                                                            &nbsp;&nbsp;&nbsp;
                                                            <DeleteOutlined style={{ display: "inline-flex", alignItems: "center" }} onClick={removeFile} />
                                                        </div>
                                                        : null}
                                                </span>
                                            </div>
                                            : 
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="receiver"
                                                >
                                                    <Input type="text" disabled/>
                                                </Form.Item>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                                {flag != 'add' && 
                                    <>
                                        <div className='title'>Receiver List</div>
                                        {flag == 'edit' && <div className='sysSearchRow sysSearchBox'>
                                            <div className='sysRow'>
                                                <div className='sysCol'>
                                                    <div className="sysTitle ">Company Name</div>
                                                    <div className="sysSerchInput">
                                                        <Input type="text" value={searchRecordModel.companyName || ''}
                                                            placeholder='Company Name'
                                                            onKeyDown={(e) => e.key === "Enter" ? searchRecord(pageSize, 1, "N", true) : null}
                                                            onChange={(e) => searchRecordChange('companyName', e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='sysCol'>
                                                    <div className="sysTitle">Email</div>
                                                    <div className="sysSerchInput">
                                                        <Input type="text" value={searchRecordModel.email || ''}
                                                            placeholder='Email'
                                                            onKeyDown={(e) => e.key === "Enter" ? searchRecord(pageSize, 1, "N", true) : null}
                                                            onChange={(e) => searchRecordChange('email', e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='sysSearchButton'>
                                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => searchRecord(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                                    <Button className="sysBtn" onClick={resetRecord} icon={<RedoOutlined />}>Reset</Button>
                                                </div>
                                            </div>
                                        </div>}
                                        <div className="sysTable" id="tableOne">
                                            <Table
                                                scroll={{ x: 1000 }}
                                                rowKey="surveyRecordId" //Key值
                                                columns={columnsRecord} //列名
                                                dataSource={tablesRecord} //数据
                                                pagination={{  //分页
                                                    showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                                    onChange: onChangeRecord,                  //上页下页或者跳页方法
                                                    onShowSizeChange: onShowSizeChangeRecord,          //每页显示条数方法
                                                    total: tablesCountRecord,        //总共多少条数据
                                                    current: currentRecord,       //当前页
                                                    pageSize: pageSizeRecord,  //每页显示多少条数据
                                                    defaultCurrent: 1,          //默认当前页为1
                                                    size: "small"
                                                }}
                                            />
                                        </div>
                                </>}
                            </Form>
                        </TabPane>
                        <TabPane key="3" tab="Evaluation Survey Detail" forceRender={true}>
                            <div className='websiteSysContentBox'>
                                <Form form={form2}>
                                    <div className='contentTitle contentTitleDisplay'>
                                        {trans.surveyScreenSchool[language]}
                                    </div>
                                    <div className='contentTitle contentTitleDisplay'>
                                        {trans.surveyScreenName[language]}
                                    </div>
                                    <div className='flexBox marginTopAndBot'>
                                        <div className='value valueJustify'>
                                            {trans.surveyScreenDesc[language]}
                                        </div>
                                        <div className='value valueJustify'>
                                            {trans.surveyScreenDesc2[language]}
                                        </div>
                                    </div> 
                                    <div className='titleSize contentTitleDisplay'>
                                        {trans.surveyScreenModel[language]}
                                    </div>
                                    <div className='titleSize'>{trans.surveyScreenModel1[language]}</div>
                                    <div className='websiteSysRow'>
                                        <div className='websiteSysCol'>
                                            <div className='websiteSysParam websiteSysParamMin '>1.{trans.surveyScreenInstitutionName[language]}</div>
                                            <div className="websiteSysInput">
                                                <Form.Item
                                                    name="organisationName"
                                                    rules={[
                                                        { required: true, message: trans.surveyScreenInstitutionName[language] },
                                                    ]}
                                                >
                                                    <Input className="input" type="text" placeholder={trans.surveyScreenInstitutionName[language]} maxLength={100} disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className="label mustFill">2.{trans.surveyScreen2[language]}</div>
                                    </div>          
                                    <div className="checkbox">
                                        <Form.Item
                                            name="cohortProgIds"
                                            rules={[
                                                { required: true, message: trans.surveyScreen2[language] },
                                            ]}
                                        >
                                            <Checkbox.Group
                                                style={{
                                                    width: '100%',
                                                }}
                                                disabled 
                                            >   
                                                <Row>
                                                    {surveyTemplateModel?.programmeModelList?.map(item => 
                                                        <Col span={8} key={item?.cohortProgId}>
                                                            <Checkbox value={String(item?.cohortProgId)}>{item?.['progTitle' + language]}</Checkbox>
                                                        </Col>      
                                                    )}
                                                </Row>
                                            </Checkbox.Group>
                                        </Form.Item>
                                    </div>
                                    <div className='boxFlexText'>
                                        5= {trans.surveyScreenAgree[language]} &nbsp;&nbsp;&nbsp;&nbsp;1= {trans.surveyScreenDisAgree[language]}
                                    </div>
                                    {questionTables?.map((item, index) => 
                                        <div className="websiteSysRow" key={item?.id}>
                                            <div className="websiteSysCol">
                                                <div className="websiteSysParam minBox mustFill">{index + 3}.{item?.question}</div>
                                                <div className="websiteSysInput boxFlex ">
                                                    <Form.Item
                                                        name={item?.id}
                                                        rules={[
                                                            { required: true, message: trans.questionIsRequired[language] },
                                                        ]}
                                                    >
                                                        <Radio.Group  buttonStyle="solid" disabled >
                                                            <Radio.Button value={5}>5</Radio.Button>
                                                            <Radio.Button value={4}>4</Radio.Button>
                                                            <Radio.Button value={3}>3</Radio.Button>
                                                            <Radio.Button value={2}>2</Radio.Button>
                                                            <Radio.Button value={1}>1</Radio.Button>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className='titleSize'>{trans.surveyScreenModel2[language]}</div>
                                    <div className='websiteSysRow'>
                                        <div className='websiteSysCol'>
                                            <div className='websiteSysParam websiteSysParamMiddle mustFill'>{questionTables.length + 2}.{surveyTemplateModel?.['sectionBQuestion1' + language]}</div>
                                            <div className="websiteSysInput">
                                                <Form.Item
                                                    name="sectionBQuestionResult1"
                                                    rules={[
                                                        { required: true, message: trans.sectionBQuestion1ResultIsRequired[language] },
                                                    ]}
                                                >
                                                    <Input min={1} max={999} placeholder={surveyTemplateModel?.['sectionBQuestion1' + language]} disabled/>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='titleSize'>{trans.surveyScreenModel3[language]}</div>
                                    {optionTables?.map((item, index) =>
                                        <div key={item?.id}>
                                            <div className='flexBox'>
                                            <div className="label">{questionTables.length + 3 + index}.{item.question}</div>
                                            </div>
                                            <div className="flexBox">
                                                <div className="websiteSysInputMax marginBot">
                                                    <Form.Item
                                                        name={item?.id}
                                                    >
                                                        <TextArea maxLength={1000} rows={3} placeholder="" disabled />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>    
                                    )}
                                    <div className='flexBox'>
                                        <div className='value valueJustify marginTop'>
                                            {trans.surveyScreenThank[language]} 
                                        </div>
                                    </div>
                                </Form>
                            </div>
                            <div className="sysSaveButton">
                                <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={edit}>{trans.cancel[Config.backLang]}</Button>
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default Survey;